"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronDown, LogOut01, Moon01, Settings01, Sun, Tool01, User01 } from "@untitledui/icons";
import { useTheme } from "next-themes";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { Button } from "@/components/base/buttons/button";
import { Dropdown } from "@/components/base/dropdown/dropdown";
import { DebugMenuPanel } from "@/components/debug/debug-menu-panel";
import { performClientLogoutAndRedirectToLogin } from "@/lib/client-logout";
import { hasClientPermission } from "@/lib/client-permissions";
import { shouldShowDebugToolbar } from "@/lib/debug-toolbar";
import { useAuth } from "@/providers/auth";
import { cx } from "@/utils/cx";
export function AccountDropdown() {
  const $ = _c(35);
  const {
    isLoggedIn,
    user
  } = useAuth();
  const router = useRouter();
  const {
    setTheme,
    resolvedTheme
  } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const [themeMounted, setThemeMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setThemeMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const isDark = themeMounted && resolvedTheme === "dark";
  if (!isLoggedIn || !user) {
    return null;
  }
  let t2;
  if ($[2] !== user.permissions || $[3] !== user.role) {
    t2 = hasClientPermission(user.role, user.permissions, "admin.panel.access");
    $[2] = user.permissions;
    $[3] = user.role;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const canAccessStaffPanel = t2;
  const staffLabel = user.role === "support" ? "Support" : "Admin";
  const staffPanelHref = user.role === "support" ? "/support/users" : "/admin";
  let t3;
  if ($[5] !== user.role) {
    t3 = shouldShowDebugToolbar(user.role);
    $[5] = user.role;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const showDebugMenu = t3;
  const handleLogout = _temp;
  const t4 = isOpen && "ring-2 ring-brand";
  let t5;
  if ($[7] !== t4) {
    t5 = cx(t4);
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <Button color="secondary" size="sm" iconTrailing={ChevronDown} className={t5}>Account</Button>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== isDark || $[12] !== router || $[13] !== setTheme || $[14] !== staffPanelHref) {
    t7 = key => {
      if (key === "my-account") {
        router.push("/account");
      } else {
        if (key === "admin") {
          router.push(staffPanelHref);
        } else {
          if (key === "theme") {
            setTheme(isDark ? "light" : "dark");
          } else {
            if (key === "log-out") {
              handleLogout();
            }
          }
        }
      }
    };
    $[11] = isDark;
    $[12] = router;
    $[13] = setTheme;
    $[14] = staffPanelHref;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Dropdown.Item id="my-account" label="My Account" icon={User01} />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== canAccessStaffPanel || $[18] !== staffLabel) {
    t9 = canAccessStaffPanel ? <Dropdown.Item id="admin" label={staffLabel} icon={Settings01} /> : null;
    $[17] = canAccessStaffPanel;
    $[18] = staffLabel;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== showDebugMenu) {
    t10 = showDebugMenu && <Dropdown.SubmenuTrigger><Dropdown.Item id="debug" label="Debug" icon={Tool01} /><Dropdown.Popover placement="left top" className="w-64"><DebugMenuPanel /></Dropdown.Popover></Dropdown.SubmenuTrigger>;
    $[20] = showDebugMenu;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = isDark ? "Light Mode" : "Dark Mode";
  const t12 = isDark ? Sun : Moon01;
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <Dropdown.Item id="theme" label={t11} icon={t12} />;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Dropdown.Item id="log-out" label="Log Out" icon={LogOut01} />;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t10 || $[27] !== t13 || $[28] !== t7 || $[29] !== t9) {
    t15 = <Dropdown.Popover placement="bottom end"><Dropdown.Menu onAction={t7}>{t8}{t9}{t10}{t13}{t14}</Dropdown.Menu></Dropdown.Popover>;
    $[26] = t10;
    $[27] = t13;
    $[28] = t7;
    $[29] = t9;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== isOpen || $[32] !== t15 || $[33] !== t6) {
    t16 = <Dropdown.Root isOpen={isOpen} onOpenChange={setIsOpen}>{t6}{t15}</Dropdown.Root>;
    $[31] = isOpen;
    $[32] = t15;
    $[33] = t6;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}
async function _temp() {
  await performClientLogoutAndRedirectToLogin();
}